<script>
import axios from 'axios';
import UserCard from '../../components/equipe/UserCard';
import Ajouter from '../../components/PageForm';
import Section from '../../components/PageSection';
import Spinner from '../../components/Spinner';

export default {
  name: 'PageUsers',
  components: {
    UserCard,
    Ajouter,
    Section,
    Spinner,
  },
  data(){
    return{
      users: null,
      erreurs: [],
      displayAll: false,
      defaultRoleId: "",
    }
  },
  mounted(){
    axios.get('users/actives/' + this.$store.state.auth.currentAgence._id)
      .then(response => (this.users = response.data));

    //Récupérer l'ID du rôle par défaut
    axios.get('roles/getByAgence/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.defaultRoleId = response.data.find(e => e.default == true)._id
    })
  },
  methods:{
    addUser(){
      var user = {
        email: document.getElementById("email").value,
        password: document.getElementById("password").value,
        passwordConfirm: document.getElementById("passwordConfirm").value,
        name: document.getElementById("name").value, //Casse : première lettre en majuscule, le reste en minuscule, sauf si espace ou tiret.
        surname: document.getElementById("surname").value, //Casse : première lettre en majuscule, le reste en minuscule, sauf si espace ou tiret.
        active: true,
        agenceId: this.$store.state.auth.currentAgence._id,
        salaire: [{date: "2020-01-01T00:00:00.000+00:00", val: document.getElementById("salaire").value}],
        roleId: this.defaultRoleId,
        tempsPartiel: false,
      };

      var formValid = true;
      this.erreurs = [];
      //adresse mail valide
      if ( 
        !user.email.includes("@") || 
        !user.email.includes(".") ||
        user.email.indexOf(".", user.email.indexOf("@")) == -1
        ) {
        formValid = false;
        this.erreurs.push("adresse mail invalide");
      }
      //concordance des mots de passe
      if (user.password !== user.passwordConfirm){
        formValid = false;
        this.erreurs.push("mots de passe différents");
      }
      //unicité de l'adresse mail
      this.users.forEach(function(e){
        if (e.email == user.email){
          formValid = false;
          this.push("adresse mail déjà existante");
        }
      }, this.erreurs);//thisArg : à quoi refer "this" dans la boucle forEach

      //Envoi à la BDD
      if(formValid){
        this.erreurs = [];
        axios.post('users/register', user)
          .then(response => {
            //J'ajoute le nouvel utilisateur dans this.users pour qu'il s'affiche dans le DOM.
            //Je lui ajoute la propriété _id communiquée dans la response du server pour que je puisse immédiatement manipuler le nouvel objet du DOM (le supprimer de la BDD par exemple)
            user._id = response.data.userId;
            this.users.push(user);
            document.getElementById("form-body-1").reset();
          })
          .catch(e => {
            this.erreurs.push(e);
          });
      }
    },
    
    // deleteUser(_id){
    //   this.erreurs = [];
    //   axios.delete('users/' + _id)
    //   .then(response => {
    //       console.log(response);
    //       //Si suppression ok sur le server, suppression sur le client (this.users).
    //       const index = this.users.findIndex(e => e._id === _id);
    //       if( index >= 0 ){
    //         this.users.splice(index, 1);
    //       } else {
    //         console.log("_id non reconnue sur le client, mais suppression effective sur le server.");
    //       }
    //   })
    //   .catch(e => {
    //       this.erreurs.push(e)
    //   });
    // },

    disableUser(_id){
      axios.put('users/' + _id,{
        active: false
      })
      .then(response => {
        console.log(response)
        //Si suppression ok sur le server, suppression sur le client (this.users).
        const index = this.users.findIndex(e => e._id === _id);
        if( index >= 0 ){
          // Si j'affiche les utilisateurs supprimés, alors je mets simplement à jour la propriété "active"
          if (this.displayAll) {
            this.users[index].active = false;
          } else { //S'ils sont masqués, alors je supprime l'user de this.users
            this.users.splice(index, 1);
          }
        } else {
          console.log("_id non reconnue sur le client, mais suppression effective sur le server.");
        }
      })
      .catch(e => {
        this.erreurs.push(e);
      })
    },

    enableUser(_id){
      axios.put('users/' + _id,{
        active: true
      })
      .then(response => {
        console.log(response)
        const index = this.users.findIndex(e => e._id === _id);
        if( index >= 0 ){
          this.users[index].active = true;
        } else {
          console.log("_id non reconnue sur le client, mais restauration effective sur le server.");
        }
      })
      .catch(e => {
        this.erreurs.push(e);
      })
    },

    clickedLink(_id){
      //Quand je clic sur une userCard, j'affiche la page de l'user
      this.$router.push('/equipe/utilisateurs/' + _id);
    },

    switchUsers(){
      if ( !this.displayAll ) {
        axios.get('users/allInAgence/' + this.$store.state.auth.currentAgence._id)
          .then(response => (this.users = response.data));
      } else {
        axios.get('users/actives/' + this.$store.state.auth.currentAgence._id)
          .then(response => (this.users = response.data));
      }
      this.displayAll = !this.displayAll;
    },
  },
}
</script>

<template>
    <div class="userCardList">
        <Ajouter label="Ajouter un nouvel utilisateur" class="ajouter" text="Ajouter" @submit="addUser()" formIndex=1 persistant>
          <template v-slot:body>
            <div class="ajouter__body">
              <input type="email"     id="email"            placeholder="e-mail"              required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
              <input type="password"  id="password"         placeholder="Mot de passe"        required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
              <input type="password"  id="passwordConfirm"  placeholder="Confirmation mdp"    required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
              <input type="text"      id="name"             placeholder="Prénom"              required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
              <input type="text"      id="surname"          placeholder="Nom"                 required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
              <input type="number"    id="salaire"          placeholder="Salaire brut"        required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
            </div>
          </template>
          <template v-slot:erreurs>
            <div v-for="erreur in erreurs" :key="erreur"> {{erreur}} </div>
          </template>
        </Ajouter>

        <Section text="Utilisateurs actifs" class="section">
          <template v-slot:body>
            <div v-if="!users">
              <Spinner />
            </div>
            <div v-else>
              <p v-if="displayAll" class="section__switchUser"><span v-on:click="switchUsers" class="section__switchUser__link"> Cliquez ici</span> pour n'afficher uniquement que les utilisateurs actifs.</p>
              <p v-else class="section__switchUser">Les utilisateurs inactifs sont masqués. <span v-on:click="switchUsers" class="section__switchUser__link">Cliquez ici</span> pour les afficher.</p>

              <div class="userGrid">
                <div v-for="user in users" :key="user._id">
                  <UserCard v-bind="user"
                    v-on:disable-user="disableUser"
                    v-on:enable-user="enableUser"
                    v-on:clicked-link="clickedLink(user._id)"
                  />
                </div>
              </div>
            </div>
          </template>
        </Section>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';


.userCardList{
  @include pageMain;
  margin-left: 0px !important;
}

.ajouter{
  margin: 0px 0 30px 0;

  &__body{
    display: flex;
    flex-wrap: wrap;
   
    & input{
      @include myFont;
      color: $black-bolder;
      margin: 5px 15px 0 0;
      width: 180px;
    }

    & #salaire{
      width: 100px;

      // Supprimer les flèches du type Number
      -moz-appearance: textfield;
      &::-webkit-inner-spin-button{
          -webkit-appearance: none;
          margin: 0;
      }
    }

  }
}

.section{
  width: 100%;
  margin: 0 0 20px 0;

  &__switchUser{
    @include myFont;
    font-size: 12px;
    margin: 0 0 15px 0;
    color: $black-bold;

    &__link{
      cursor: pointer;
      color: $main;
      text-decoration: underline;
    }
  }
}

.userGrid{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: 7px 25px; //row-gap column-gap
}

</style>
